module.exports = __webpack_public_path__ + "static/hero-4a167b1feee9a73b4a5e1ba221abe9f8.jpg";